import { shallowEqual } from 'react-redux';
import { useSsSelector } from '~SpectateStore';
import {
    selectIsInplay,
    selectHomeCompetitor,
    selectAwayCompetitor,
    selectHomeTeamName,
    selectAwayTeamName,
    selectHomeTeamSlug,
    selectAwayTeamSlug,
    selectIsStreamingAvailable,
    selectFixtureId,
    selectVisualizationProvider,
    selectMatchStatus,
    selectStartTime,
    selectCashoutAvailable,
    selectEventSportId,
    selectEventCategoryId,
    selectEventTournamentId,
    selectEventGtmAttribute,
    selectMarketGroupsByEventId,
    selectSelectedMarketTab,
} from '~SpectateStore/selectors/eventsSelectors';

export const useIsInplay = eventId => useSsSelector(state => selectIsInplay(state, eventId));
export const useHomeCompetitor = eventId => useSsSelector(state => selectHomeCompetitor(state, eventId), shallowEqual);
export const useAwayCompetitor = eventId => useSsSelector(state => selectAwayCompetitor(state, eventId), shallowEqual);
export const useHomeTeamName = eventId => useSsSelector(state => selectHomeTeamName(state, eventId));
export const useAwayTeamName = eventId => useSsSelector(state => selectAwayTeamName(state, eventId));
export const useHomeTeamSlug = eventId => useSsSelector(state => selectHomeTeamSlug(state, eventId));
export const useAwayTeamSlug = eventId => useSsSelector(state => selectAwayTeamSlug(state, eventId));
export const useIsStreamingAvailable = eventId => useSsSelector(state => selectIsStreamingAvailable(state, eventId));
export const useFixtureId = eventId => useSsSelector(state => selectFixtureId(state, eventId));
export const useVisualizationProvider = eventId => useSsSelector(state => selectVisualizationProvider(state, eventId));
export const useMatchStatus = eventId => useSsSelector(state => selectMatchStatus(state, eventId));
export const useStartTime = eventId => useSsSelector(state => selectStartTime(state, eventId));
export const useCashoutAvailable = eventId => useSsSelector(state => selectCashoutAvailable(state, eventId));
export const useEventSportId = eventId => useSsSelector(state => selectEventSportId(state, eventId));
export const useEventCategoryId = eventId => useSsSelector(state => selectEventCategoryId(state, eventId));
export const useTournamentId = eventId => useSsSelector(state => selectEventTournamentId(state, eventId));
export const useEventGtmAttribute = eventId => useSsSelector(state => selectEventGtmAttribute(state, eventId));
export const useMarketsGroupsByEventId = eventId => useSsSelector(state => selectMarketGroupsByEventId(state, eventId));
export const useSelectedMarketTab = eventId => useSsSelector(state => selectSelectedMarketTab(state, eventId));
